<template lang="pug">
  .component-tabbed-charging-sessions-list
    .container
      base-list(
        :component="component",
        :dataLoader="dataLoader",
        :showPerPageSelect="false",
        ref="chargingSessionsBaseList",
        :component-type="reservation !== null ? 'reservation' : 'listing'"
      )
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from "./BaseList"

  export default {
    name: "ChargingSessionsList",
    components: {BaseList},
    data() {
      return {
        component: require('src/components/backoffice/ChargingSession'),
      }
    },
    methods: {
      dataLoader(callback, page = 1, resultsPerPage = 25) {
        const body = this.reservation ? {reservation_id: this.reservation.id} : null
        KeplerBackofficeSdk.chargingSessions.list(page, resultsPerPage, body).all((data) => {
          callback(data)
        })
      },
    },
    props: {
      reservation: {
        type: Object,
        default: null,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ChargingSessionsList.vue?3c98d014